import React, { useState, useEffect } from "react";
import ButtonEdit from "../../components/Button/ButtonEdit";
import ButtonDelete from "../../components/Button/ButtonDelete";
import ButtonTel from "../../components/Button/ButtonTel";
import ButtonMail from "../../components/Button/ButtonMail";
import { deletePartenaireKata } from "../../services/partenaireskataServices";
import EditPartenaireModal from "./EditPartenaireModal";
import { getUserById } from "../../services/userServices";
import { toast } from "react-toastify";

const defaultAvatar = "/img/default_image.jpg";

const gradeImages = {
  "1er Dan": "/img/belt/ceinture_judo_1D.png",
  "2ème Dan": "/img/belt/ceinture_judo_2D.png",
  "3ème Dan": "/img/belt/ceinture_judo_3D.png",
  "4ème Dan": "/img/belt/ceinture_judo_4D.png",
  "5ème Dan": "/img/belt/ceinture_judo_5D.png",
  "6ème Dan": "/img/belt/ceinture_judo_rouge_blanche.png",
  "7ème Dan": "/img/belt/ceinture_judo_rouge_blanche.png",
  "8ème Dan": "/img/belt/ceinture_judo_rouge.png",
  "9ème Dan": "/img/belt/ceinture_judo_rouge.png",
  "10ème Dan": "/img/belt/ceinture_judo_rouge.png",
};

const PartenaireKataCard = ({
  partenaire,
  userRole,
  refreshPartenairesList,
  user,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    const fetchAuthor = async () => {
      if (partenaire.user_id) {
        const authorData = await getUserById(partenaire.user_id);
        setAuthor(authorData);
      }
    };
    fetchAuthor();
  }, [partenaire.user_id]);

  const handleDeletePartenaire = async () => {
    if (
      !window.confirm(
        "Êtes-vous sûr de vouloir supprimer ce partenaire de Kata ?"
      )
    )
      return;

    try {
      await deletePartenaireKata(partenaire.id);
      toast.success("Partenaire supprimé avec succès.");
      refreshPartenairesList();
    } catch (error) {
      console.error("Erreur lors de la suppression du partenaire:", error);
      toast.error("Erreur lors de la suppression du partenaire.");
    }
  };

  const canEditOrDelete =
    user?.userId === partenaire.user_id ||
    userRole === 1 ||
    userRole === 2 ||
    userRole === 5;

  const beltImg = gradeImages[partenaire.passage_grade];

  return (
    <>
      <article className="relative flex flex-col bg-white/95 dark:bg-slate-900/95 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl shadow-md hover:shadow-xl transition-all duration-200 overflow-hidden">
        {/* Bandeau grade */}
        <div className="relative h-24 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-700 flex items-center justify-between px-4">
          <div className="flex items-center gap-3">
            {beltImg && (
              <img
                src={beltImg}
                alt={partenaire.passage_grade}
                className="h-12 w-auto object-contain drop-shadow-md"
              />
            )}
            <div>
              <p className="text-[11px] uppercase tracking-[0.2em] text-primary/60 font-semibold">
                Passage de grade
              </p>
              <p className="text-sm sm:text-base font-bold text-white">
                {partenaire.passage_grade}
              </p>
              {partenaire.club && (
                <p className="text-xs text-slate-200">
                  Club : {partenaire.club}
                </p>
              )}
            </div>
          </div>

          {author && (
            <div className="flex items-center gap-2">
              <p className="hidden sm:block text-[11px] text-slate-200 text-right">
                Proposé par
                <br />
                <span className="font-semibold">
                  {author.nom} {author.prenom}
                </span>
              </p>
              <img
                src={author.photoURL || defaultAvatar}
                alt={author.nom}
                className="h-10 w-10 rounded-full border border-white/60 object-cover"
              />
            </div>
          )}
        </div>

        {/* Contenu */}
        <div className="flex flex-col flex-1 p-4 space-y-3">
          <div
            className="text-xs sm:text-sm text-slate-700 dark:text-slate-200 leading-relaxed line-clamp-[10]"
            dangerouslySetInnerHTML={{ __html: partenaire.content }}
          />

          {/* Contacts + actions */}
          <div className="mt-2 pt-3 border-t border-slate-100 dark:border-slate-700 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              {partenaire.tel && <ButtonTel tel={partenaire.tel} />}
              {partenaire.mail && <ButtonMail mail={partenaire.mail} />}
            </div>

            {canEditOrDelete && (
              <div className="flex items-center gap-2">
                <ButtonEdit
                  onClick={() => setEditModalOpen(true)}
                  className="btn-xs"
                />
                <ButtonDelete
                  onClick={handleDeletePartenaire}
                  className="btn-xs"
                />
              </div>
            )}
          </div>
        </div>
      </article>

      {editModalOpen && (
        <EditPartenaireModal
          partenaire={partenaire}
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          refreshList={refreshPartenairesList}
        />
      )}
    </>
  );
};

export default PartenaireKataCard;
